$(window).on('load', function () {
  // Toggle dropdown open/close
  $(document).on('click', '[data-js="sf-trigger"]', function () {
    const $dropdown = $(this).closest('[data-js="sf-dropdown"]');
    const isOpen = $dropdown.hasClass('is-open');
    $dropdown.toggleClass('is-open', !isOpen);
    $(this).attr('aria-expanded', String(!isOpen));
  });

  // Select an option
  $(document).on('click keydown', '[data-js="sf-option"]', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    if (e.type === 'keydown') e.preventDefault();
    const $dropdown = $(this).closest('[data-js="sf-dropdown"]');
    $dropdown.find('[data-js="sf-trigger-text"]').text($(this).text());
    $dropdown.find('[data-js="sf-hidden-value"]').val($(this).data('value')).data('filterValue', $(this).data('filterValue'));
    $dropdown.find('[data-js="sf-option"]').removeAttr('aria-selected');
    $(this).attr('aria-selected', 'true');
    $dropdown.find('[data-js="sf-trigger"]').attr('aria-expanded', 'false');
    $dropdown.removeClass('is-open');
  });

  // Close on outside click
  $(document).on('click', function (e) {
    if (!$(e.target).closest('[data-js="sf-dropdown"]').length) {
      $('[data-js="sf-dropdown"]').removeClass('is-open');
      $('[data-js="sf-trigger"]').attr('aria-expanded', 'false');
    }
  });

  // Submit handler
  $('.product_finder_submit').on('click', function () {
    const form = $(this).closest('form');
    const $input = form.find('.product_finder_option');
    const tagValue = $input.val();
    const filterValue = $input.data('filterValue');
    const collectionHandle = form.find('.collection_handle').val() || 'all';

    if (!tagValue || tagValue === 'skin-concern') {
      window.location.href = `/collections/${collectionHandle}/`;
      return;
    }

    const url = `/collections/${collectionHandle}/?filter.p.m.custom.skin_concern=${encodeURIComponent(filterValue || tagValue)}`;
    window.location.href = url;
  });
});
